import { render, staticRenderFns } from "./demo-plugin-recipients.vue?vue&type=template&id=4771205c&"
import script from "./demo-plugin-recipients.vue?vue&type=script&lang=js&"
export * from "./demo-plugin-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports